/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-vars */
import { useMemo, useState } from "react";
import { FormattedMessage } from "react-intl";

import { ReactComponent as SearchIcon } from "assets/images/iconsV2/Search.svg";
import { ReactComponent as ClearIcon } from "assets/images/iconsV2/x-circle-grey.svg";
import Button from "components/v2/Button/Button";
import { DualListItemProps } from "../DualList.types";

function DualListItem(props: DualListItemProps) {
  const {
    label,
    actionButtonLabel,
    actionButtonFilterLabel,
    actionButtonVariant,
    actionButtonOnClick,
    options,
    onChange,
    showNoDataMessage = false,
  } = props;
  const [searchText, setSearchText] = useState("");

  const filteredOptions = useMemo(
    () => options.filter((item: any) => item.label.toLowerCase().includes(searchText.toLowerCase())),
    [options, searchText],
  );

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-sm">
        {label ? <div className="text-secondary-v2 text-sm font-medium">{label}</div> : <div />}
        {(options?.length > 0 || !showNoDataMessage) && (
          <Button
            disabled={filteredOptions?.length === 0}
            variant={actionButtonVariant}
            label={searchText?.length > 0 ? actionButtonFilterLabel : actionButtonLabel}
            onClick={() => actionButtonOnClick(filteredOptions)}
          />
        )}
      </div>
      <div className="dual-list__list-container">
        <div className="dual-list__search">
          <SearchIcon className="position-absolute" />
          <input
            className="dual-list__search-input"
            type="text"
            placeholder="Search"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          {searchText?.length > 0 && <ClearIcon className="dual-list__search-clear" onClick={() => setSearchText("")} />}
        </div>
        <div className="dual-list__items-container">
          {options?.length === 0 && showNoDataMessage && (
            <div className="w-100 h-100 d-flex align-items-center justify-content-center text-tertiary text-sm">
              <FormattedMessage id="dualList.noDataAddedYet" defaultMessage="No data added yet" />
            </div>
          )}

          {filteredOptions.map((item: any) => (
            <div key={item.value} className="dual-list__items" onClick={() => onChange(item.value)}>
              {item.label}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DualListItem;
